import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { emsPlayer } from 'src/models/emsModels';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrl: './notes-dialog.component.scss'
})
export class NotesDialogComponent {

  teamName = "";
  teamNotes = "";
  playerList = new Array<emsPlayer>();

  constructor(public dialogRef: MatDialogRef<NotesDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}
  
    ngOnInit() {
      this.teamName = this.data.teamName;
      this.teamNotes = this.data.teamNotes;
      this.playerList = this.data.playerList;
      this.playerList.sort((a,b) => a.position - b.position);
    }
}
